import { render, staticRenderFns } from "./VideoView.vue?vue&type=template&id=44198740&scoped=true"
import script from "./VideoView.vue?vue&type=script&lang=js"
export * from "./VideoView.vue?vue&type=script&lang=js"
import style0 from "./VideoView.vue?vue&type=style&index=0&id=44198740&prod&lang=scss&scoped=true"
import style1 from "./VideoView.vue?vue&type=style&index=1&id=44198740&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44198740",
  null
  
)

export default component.exports